/**
 *
 *  SeniorParkingOperatorDxGrid12970
 *
 */

import { SeniorParkingOperatorDxGrid } from 'pages/Requests/SeniorParkingOperator';
import {
  CURRENT_DAY_REQUESTS,
  NOT_REJECTED_REQUESTS,
  REQUESTS_FOR_COMCITY_SENIOR_PARKING_OPERATOR,
} from 'domain/Data/Filters/constants';

class SeniorParkingOperatorDxGrid12970 extends SeniorParkingOperatorDxGrid {
  getFilters() {
    const { viewName } = this.props;
    const filters = [REQUESTS_FOR_COMCITY_SENIOR_PARKING_OPERATOR];
    if (viewName === 'today') {
      filters.push(CURRENT_DAY_REQUESTS);
      filters.push(NOT_REJECTED_REQUESTS);
    }
    return filters;
  }
}

export default SeniorParkingOperatorDxGrid12970;
